module.exports = __webpack_public_path__ + "static/media/2020.6.28雨污分流会议.5b10c88d.jpg";